import { useStore } from '../../../store/store';
import './VinylsRoulette.css';
import { useRef, useState, MouseEvent } from 'react';
import { translations } from '../../../configs/translations';
import { Vehicle } from '../../../models/Vehicle';
import { VinylCard } from '../../../components/vinyls/vinylsCard/VinylCard';
import { DropdownMenu } from '../../../components/dropdown/DropdownMenu';

interface VinylsRouletteProps {
    selectedStickers?: number[];
    items: {name: string, image: string, onClick: () => void, id: number}[];
    groups?: {id: number, stickers: number[]}[];
    selectGroup: (groupId: number) => void;
}

export const VinylsRoulette = ({ selectedStickers, items, groups, selectGroup }: VinylsRouletteProps) => {
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const rouletteRef = useRef<HTMLDivElement>(null);
    const language = useStore(state => state.language) as keyof typeof translations;
    const t = translations[language];

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const handleMouseDown = (e: MouseEvent) => {
        setIsDragging(true);
        if (rouletteRef.current) {
            setStartX(e.pageX - rouletteRef.current.offsetLeft);
            setScrollLeft(rouletteRef.current.scrollLeft);
        }
    };

    const handleMouseMove = (e: MouseEvent) => {
        if (!isDragging) return;
        e.preventDefault();
        if (rouletteRef.current) {
            const x = e.pageX - rouletteRef.current.offsetLeft;
            const walk = (x - startX) * 1.1;
            rouletteRef.current.scrollLeft = scrollLeft - walk;
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleMouseLeave = () => {
        setIsDragging(false);
    };

    return (
        <div className="vinyls-roulette-main-container">
            <div className="vinyls-filters">
                <DropdownMenu 
                    title={t.all} 
                    minWidth={150}
                    children={groups?.map((group) => {
                        return (
                            <div
                                key={group.id} 
                                onClick={() => {selectGroup(group.id); setIsDropdownOpen(false)}}
                            >
                                {'Group ' + group.id}
                            </div>
                        )
                    })} 
                    isOpen={isDropdownOpen}
                    setIsOpen={(isOpen: boolean) => {
                        setIsDropdownOpen(isOpen)
                    }}
                />
                <div className='vinyls-counter'>
                    <p>{items.length}/1000</p>
                </div>
            </div>
            <div 
                className="vinyls-roulette"
                ref={rouletteRef}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseLeave}
            >
                {items.sort((a, b) => a.id - b.id).map((item) => (
                    <VinylCard 
                        name={item.name} 
                        image={item.image}
                        onSelect={item.onClick}
                        isSelected={selectedStickers?.includes(item.id) || false}
                    />
                ))}
            </div>
        </div>
    )
}
